import React from 'react';
import { AttributeGroupFormFieldRow } from './AttributeGroupFormFieldRow';
import { AttributeGroupFormRule } from './AttributeGroupFormRule';
import { AttributeGroupFormRemoveButton } from './AttributeGroupFormRemoveButton';
import { byName, Fieldset } from '../../../../_lib/Form2';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { RuleInState } from '../AttributeGroupForm.types';

type AttributeGroupFormRuleFieldSet = {
  rule: RuleInState;
  index: number;
  attributeRulesCollectionName: string;
  removeRule(generatedKey: number): void;
  showRemoveButton: boolean;
};

/**
 * Attribute Group Rule inside a fieldset.
 */
export function AttributeGroupFormRuleFieldSet({
  index,
  rule,
  attributeRulesCollectionName,
  removeRule,
  showRemoveButton,
}: AttributeGroupFormRuleFieldSet) {
  const { t } = useSonTranslation('AttributeGroups');

  const attributeName = rule.param.find(byName('attributeName'));
  const condition = rule.param.find(byName('condition'));
  const conditionValue = rule.param.find(byName('conditionValue'));
  const position = index + 1;

  return (
    <Fieldset legend={`${position}. ${t('form.ruleFieldSetLegend')}`} key={rule.generatedKey}>
      <AttributeGroupFormFieldRow>
        <div className="attribute-group-form__field-row-inner">
          <AttributeGroupFormRule
            attributeName={attributeName}
            condition={condition}
            conditionValue={conditionValue}
            collectionName={attributeRulesCollectionName}
            index={index}
            initWithEmptyValues={rule.unpersisted}
          />
        </div>
        {showRemoveButton && (
          <AttributeGroupFormRemoveButton position={position} removeRule={() => removeRule(rule.generatedKey)} />
        )}
      </AttributeGroupFormFieldRow>
    </Fieldset>
  );
}
